import { render, staticRenderFns } from "./sideboardDeviceCells.vue?vue&type=template&id=6c916ac4&scoped=true&"
import script from "./sideboardDeviceCells.vue?vue&type=script&lang=js&"
export * from "./sideboardDeviceCells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c916ac4",
  null
  
)

export default component.exports